<template>
  <!-- La supervision ZEborne du pays de l'organisation : on l'appelle ; sans numéro, on lui écrit. Rien de grisé. -->
  <v-btn v-if="phone" :block="block" :small="small" outlined color="primary" class="field-issue__button" :height="small ? undefined : 40" :href="`tel:${phone.replace(/\s/g, '')}`">
    <v-icon left>mdi-headset</v-icon>{{ $t('onboarding.field.call-supervision') }} · {{ phone }}
  </v-btn>
  <v-btn v-else-if="email" :block="block" :small="small" outlined color="primary" class="field-issue__button" :height="small ? undefined : 40" :href="`mailto:${email}`">
    <v-icon left>mdi-email-outline</v-icon>{{ $t('onboarding.field.write-supervision') }}
  </v-btn>
</template>

<script>
import { SUPERVISION_PHONE } from './FieldMixin'

/** Joindre la supervision depuis le terrain : quand on ne trouve pas la pose, ou quand quelque chose bloque. */
export default {
  name: 'FieldSupervisionButton',

  props: {
    block: { type: Boolean, default: false },
    /** Dans un texte (un avertissement) : la taille des autres boutons de la phrase. */
    small: { type: Boolean, default: false },
    /** La supervision du pays de l'organisation, telle que la commande la donne : { phone, email }. */
    contact: { type: Object, default: null },
  },

  computed: {
    phone() {
      return this.contact?.phone || SUPERVISION_PHONE
    },

    email() {
      return this.contact?.email || null
    },
  },
}
</script>
